<div class="container-fluid full-height pt-5">
  <div class="row">
    <div class="col-sm-12 col-md-6 col-lg-4 d-flex">
      <div class="card-overview col">
        <h3 class="title">{{ 'INSTITUTION_MANAGEMENT.INFORMATION' | translate }}</h3>
        <div class="form-group">

          <div *ngIf="isgroup && (institutionData && institutionData.institution.institution.bedSize)">
            <label>{{'INSTITUTION_MANAGEMENT.BED_SIZE' | translate }}</label>
            <div>
              {{institutionData? institutionData.institution.institution.bedSize: " "}} {{'INSTITUTION_MANAGEMENT.NOS' | translate}}
            </div>
          </div>

          <div *ngIf="institutionData && (institutionData.institution.institution.addressLine1 || institutionData.institution.institution.addressLine2) ">
            <label>{{'INSTITUTION_MANAGEMENT.STREET' | translate }}</label>
            <div>
              {{institutionData ? institutionData.institution.institution.addressLine1: "" }} {{institutionData ? institutionData.institution.institution.addressLine2: ""}}
            </div>
          </div>

          <div *ngIf="institutionData && institutionData.institution.institution.zipCode">
            <label>{{'INSTITUTION_MANAGEMENT.POSTAL_CODE' | translate }}</label>
            <div>
              {{institutionData? institutionData.institution.institution.zipCode: ""}}
            </div>
          </div>

          <div *ngIf="institutionData && institutionData.institution.institution.city">
            <label>{{'AUTHORIZATION.CITY' | translate }}</label>
            <div>
              {{(institutionData? institutionData.institution.institution.city:"") | translate | labelSanitizer}}
            </div>
          </div>

          <div *ngIf="institutionData && institutionData.institution.institution.phone">
            <label>{{'AUTHORIZATION.PHONE' | translate}}</label>
            <div>
              {{institutionData? institutionData.institution.institution.phone: ""}}
            </div>
          </div>

          <div *ngIf="institutionData && institutionData.institution.institution.fax">
            <label>{{'AUTHORIZATION.FAX' | translate}}</label>
            <div>
              {{institutionData? institutionData.institution.institution.fax:""}}
            </div>
          </div>
        </div>
        <div class="form-group">
          <p class="m-0">{{'INSTITUTION_MANAGEMENT.CONTACT_PERSON' | translate }}</p>
          <label>{{'INSTITUTION_MANAGEMENT.CONTACT_PERSON' | translate }}</label>
          <div>
            {{institutionData ? institutionData?.adminUser?.name : ""}}
          </div>
          <label>{{'INSTITUTION_MANAGEMENT.CONTACT_PERSON_EMAIL' | translate }}</label>
          <div>
            {{institutionData ? institutionData.adminUser?.email : ""}}
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-sm-12 col-md-6 col-lg-4 d-flex" *ngIf="isgroup">
      <div class="card-overview col">
        <h3 class="title">{{ "INSTITUTION_MANAGEMENT.LICENSE" | translate }}</h3>
        <div class="form-group">
          <label>{{'AUTHORIZATION.PRODUCT_PACKAGE' | translate }}</label>
          <div>
            {{(institutionData ? institutionData.institution.institution.productPackage ? (institutionData.institution.institution.productPackage.packageName | translate  | labelSanitizer): "" : "") | translate}}
          </div>
        </div>
        <div class="form-group">
          <label>{{ translationKeys.Authorization.UserAccountAmount | translate }}</label>
          <div>
            {{institutionData? institutionData.institution.institution.userLicense: ""}}
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4 d-flex" *ngIf="(config.userData?.roleName.roleId == 4) &&
                        (institutionData?.institution.institution?.activateWebKess) &&
                          ((institutionData?.institution.institution?.countryID == 3) ||
                           (institutionData?.institution.institution?.countryID == 219) ||
                            (institutionData?.institution.institution?.countryID == 15))">
      <div class="card-overview col">
        <h3 class="title">{{ "WEBKESS_INTEGRATION.WEBKESS.INTERFACE_1" | translate }}</h3>
        <div class="form-group">
          <p>{{'WEBKESS_INTEGRATION.WEBKESS.ENABLED_INTERFACE' | translate }}</p>
          <div class="enabled-interfaces">
            <div class="round-interface" *ngIf="recentExport?.activateObservation">
              <label class="name-interface">{{'CONFIGURE.OBSERVATION' | translate}}</label>
            </div>
            <div class="round-interface" *ngIf="recentExport?.activateConsumption">
              <label class="name-interface">{{'CONFIGURE.CONSUMPTION' | translate}}</label>
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="recentExport?.recentObservationExportedOn || recentExport?.recentConsumptionExportedOn">
          <p>{{'WEBKESS_INTEGRATION.LAST_TRANSFER' | translate }}</p>
          <div>
            <label>{{'WEBKESS_INTEGRATION.OBSERVATION_LAST_UPLOADED' | translate}}</label>
            <div>{{recentExport?.recentObservationExportedOn }}</div>
          </div>
          <div>
            <label>{{'WEBKESS_INTEGRATION.CONSUMPTION_LAST_UPLOADED' | translate}}</label>
            <div>{{recentExport?.recentConsumptionExportedOn }}</div>
          </div>
        </div>

      </div>
    </div>

    <div class="col-sm-12 col-md-6 col-lg-4 d-flex" *ngIf="institutionData && institutionData.groupInstitutions">
      <div class="card card-overview col">
        <h3 class="title">{{ "INSTITUTION_MANAGEMENT.ASSOCIATED_INSTITUTIONS" | translate }}</h3>
        <div class="form-group">
          <label>{{'INSTITUTION_MANAGEMENT.INSTITUTIONS' | translate }}</label>
          <ul *ngFor="let list of groupInstitutionlist;let i = index">
            <li>{{list}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>